import { apiService } from "../../app.service";

export const setMemberPasswordApi = apiService.injectEndpoints({
  endpoints: (builder) => ({
    verifyMemberToken: builder.mutation({
      query: (data) => ({
        // ✅ Use existing check-email endpoint
        url: "/member/check-email",
        method: "POST",
        body: { email: data.email }, // Sirf email bhejo
      }),
      // Transform response to match expected format
      transformResponse: (response) => {
        return {
          success: response.success,
          data: response.data
        };
      },
    }),
    setMemberPassword: builder.mutation({
      query: (data) => ({
        // ✅ Use existing set-password endpoint
        url: "/member/set-password",
        method: "POST",
        body: {
          email: data.email,
          password: data.password,
          token: data.token // Token bhi bhejo
        },
      }),
    }),
  }),
});

export const {
  useVerifyMemberTokenMutation,
  useSetMemberPasswordMutation,
} = setMemberPasswordApi;